"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const FeedbackBubble = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M14.692 18l-2.22 4.123c-.26.485-.68.49-.944 0L9.308 18H2.992A.994.994 0 0 1 2 17V3c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1h-6.316zm5.808-1.5v-13h-17v13h6.704L12 19.836l1.796-3.336H20.5zm-7.386-2.59c0-.6-.492-1.072-1.114-1.072-.622 0-1.114.471-1.114 1.073 0 .601.492 1.073 1.114 1.073.622 0 1.114-.472 1.114-1.073zm-2.14-8.947l.165 6.617h1.722l.164-6.617h-2.05z", children: " " })
] });
var FeedbackBubble_default = FeedbackBubble;
export {
  FeedbackBubble_default as default
};
